module.exports = __webpack_public_path__ + "static/img/bannerTxt4.1bb5914f.png";